<template>
  <donut-chart-card
    :size="size"
    :title="title"
    :value="data"
    :init-total="total"
    :unit="unit"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="!!projectId"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart06',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
    title: {
      type: String,
      default: () => "월별 안전·보건 교육 이수 현황"
    },
    unit: {
      type: String,
      default: () => "명"
    },
    boardIds: {
      type: Array,
      default: () => [434]
    },
    fieldCode: {
      type: String,
      default: undefined,
    },
    graphId: {
      type: Number,
      default: () => 6
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
  },
  data () {
    return {
      data: [{label: '데이터 없음', value: 0}],
      total: '0',
      cache: {},
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      const cacheKey = `detail_06_${currentYear}_${currentMonth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }


      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      const 이번달시작날짜 = new Date(currentYear, currentMonth - 1, 1);
      const 이번달마지막날짜 = new Date(currentYear, currentMonth, 0);
      const conditions = [
        {key: 'body.education_date', operator: '>=', value: 이번달시작날짜.format('yyyy-MM-dd')},
        {key: 'body.education_date', operator: '<=', value: 이번달마지막날짜.format('yyyy-MM-dd')},
      ];

      const params = {
        projectId: this.projectId,
        boardId : 434,
        page: 1,
        perPage: 10000,
        conditions,
        withMeta: true,
        metaKeys: [
          "body.stdInfo.부서명_과",
          "body.participants_attended",
        ],
        onlyMeta: true,
        withoutRelation: true,
        forDashboard: true,  // 대시보드용 조회
      }

      const response = await this.$store.dispatch('board/LOAD_POST_LIST', params);
      const postList = response.data || [];

      const data = [];
      for (const post of postList) {
        const 과이름 = (post.postContents.body && post.postContents.body.stdInfo && post.postContents.body.stdInfo.부서명_과) || '기타';
        const 교육이수자수 = Number(post.postContents.body.participants_attended) || 0;

        const foundRow = data.find((row) => row.label === 과이름);

        if (foundRow) {
          foundRow.count += 교육이수자수;
        } else {
          data.push({label: 과이름, count: 교육이수자수});
        }
      }

      this.cache[cacheKey] = data;
      return data;
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      const rowSum = data.reduce((acc, row) => {
        return acc + row.count;
      }, 0);
      data.sort((a, b) => b.count - a.count);


      const list = [];
      let no = 1;

      for (const row of data) {
        list.push({
          label: row.label,
          value: row.count,
        });
        no += 1;

        if (no > 5) break;
      }

      this.data = list;
      this.total = rowSum;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
